import { ref, computed } from 'vue';
import bookappointmentApi from '../../../api/bookappointment-api';
import { DEFAULT_ADDRESS, TIME_RESERVATION_TA_TYPES } from '../constants/constants';
import { useBranches } from './branches';
import { useTa } from './ta';
import { useTheme } from './theme';

const urlParams = new URLSearchParams(window.location.search);
const token = ref(urlParams.get('token'));
const { setTheme, setThemeId, getTheme } = useTheme();
const { addressRef } = useBranches();
const { setType } = useTa();
const STATES = {
	INIT: Symbol('INIT'),
	ERROR: Symbol('ERROR'),
	SUCCESS: Symbol('SUCCESS')
};
const state = ref(STATES.INIT);
const handleShiwaParams = async ({ temaId, appType }) => {
	if (token.value) {
		try {
			const { data } = await bookappointmentApi.getAppointment(token.value);
			setTheme(data.theme);
			setThemeId(data.theme.id);
			setType(data.clientType);
			addressRef.value = data.branchAddress;
			state.value = STATES.SUCCESS;
		} catch (err) {
			state.value = STATES.ERROR;
		}
	} else {
		getTheme(temaId);
		const type = TIME_RESERVATION_TA_TYPES[appType];
		setType(type);
		addressRef.value = DEFAULT_ADDRESS;
	}
};
const technicalError = computed(() => state.value == STATES.ERROR);

export const useToken = () => {
	return {
		handleShiwaParams,
		technicalError
	};
};
